<template>
    <span class="ml-1">
        <span title="Sessions provided this month">[{{ t.nb_sessions_month }}</span>
        <span> | </span>
        <span title="Sessions provided this year">{{ t.nb_sessions_year }}</span>
        <span> | </span>
        <span title="Working hours controlled this year">{{ numberFormat(t.working_controlled_hours) }}</span>
        <span> | </span>
        <span title="Working hours blocked this year">{{ numberFormat(t.working_blocked_hours) }}]</span>
    </span>
</template>
<script>
const formater = new Intl.NumberFormat("fr-FR");

export default {
    props: {
      t: {
        type: Object,
        required: true
      }
    },
    methods: {
        numberFormat(number) {
            return formater.format(number);
        },
    }
}
</script>